var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.6641,
    cy: 20.01,
    r: 20,
    fill: "#FC3033"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3636 11.6102L28.9844 24.8102C29.0546 24.9318 29.0916 25.0698 29.0916 25.2102C29.0916 25.3507 29.0546 25.4886 28.9844 25.6102C28.9142 25.7318 28.8132 25.8328 28.6916 25.903C28.57 25.9733 28.432 26.0102 28.2916 26.0102H13.05C12.9096 26.0102 12.7716 25.9733 12.65 25.903C12.5284 25.8328 12.4274 25.7318 12.3572 25.6102C12.287 25.4886 12.25 25.3507 12.25 25.2102C12.25 25.0698 12.287 24.9318 12.3572 24.8102L19.978 11.6102C20.0482 11.4886 20.1492 11.3876 20.2708 11.3174C20.3924 11.2472 20.5304 11.2103 20.6708 11.2103C20.8112 11.2103 20.9492 11.2472 21.0708 11.3174C21.1924 11.3876 21.2934 11.4886 21.3636 11.6102ZM14.4356 24.4102H26.906L20.6716 13.6102L14.4356 24.4102ZM19.8708 22.0102H21.4708V23.6102H19.8708V22.0102ZM19.8708 16.4102H21.4708V20.4102H19.8708V16.4102Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInYellow);
export default __webpack_public_path__ + "static/media/IN_yellow.2076162c16cc79c3c5ec134b4eef8761.svg";
export { ForwardRef as ReactComponent };